import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { TERMS, TermsBody } from "@/data/terms";
import { ScrollText, ArrowLeft, Printer } from "lucide-react";

export default function TermsPage() {
  const { lang } = useLang();
  const terms = TERMS[lang] || TERMS.de;

  return (
    <div data-testid="terms-page" className="min-h-screen pt-24 pb-16 bg-[#05050A]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <Link to="/" className="inline-flex items-center gap-2 text-xs text-[#A0A0B0] hover:text-[#00F0FF] mb-6 transition-colors">
          <ArrowLeft className="w-3.5 h-3.5" /> {lang === "de" ? "Zurück" : lang === "fr" ? "Retour" : "Back"}
        </Link>

        <div className="flex items-start gap-4 mb-8">
          <div className="w-12 h-12 flex items-center justify-center neon-border rounded-xl flex-shrink-0">
            <ScrollText className="w-5 h-5 text-[#00F0FF]" />
          </div>
          <div>
            <span className="text-[10px] font-['JetBrains_Mono'] text-[#00F0FF] tracking-[0.3em] uppercase block mb-1">
              Project Radar AR
            </span>
            <h1 className="font-['Outfit'] text-2xl sm:text-3xl font-bold text-white leading-tight mb-2">
              {terms.title}
            </h1>
            <p className="text-sm text-[#A0A0B0] leading-relaxed max-w-xl">
              {terms.intro}
            </p>
          </div>
        </div>

        {/* Body */}
        <article className="glass-surface rounded-2xl border border-white/5 p-6 sm:p-8">
          <TermsBody terms={terms} />

          <div className="mt-8 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <span className="text-[11px] font-['JetBrains_Mono'] text-[#606070]">
              {terms.footer.lastUpdated}: 27.04.2026 · v2026-04-27
            </span>
            <button
              onClick={() => window.print()}
              data-testid="terms-print-btn"
              className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-white/5 hover:bg-white/10 text-xs text-[#A0A0B0] hover:text-white transition-colors"
            >
              <Printer className="w-3 h-3" /> {terms.footer.printPdf}
            </button>
          </div>
        </article>
      </div>
    </div>
  );
}
